import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FieldFilter from '../shared/FieldFilter';
import { DEMAND_TYPE_FILTER_OPTIONS } from '../../services/demandTypeService';

const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: flex-start;
`;

const DashboardDemandTypeFilter = ({
  selectedValues,
  onValuesChange,
  disabled = false,
  fieldId = 'dashboard-demand-type-filter',
}) => (
  <FilterBar>
    <FieldFilter
      label="Tipo de demanda:"
      fieldId={fieldId}
      selectedValues={selectedValues}
      onValuesChange={onValuesChange}
      items={DEMAND_TYPE_FILTER_OPTIONS}
      disabled={disabled}
      inlineToolbar
    />
  </FilterBar>
);

DashboardDemandTypeFilter.propTypes = {
  selectedValues: PropTypes.arrayOf(PropTypes.string),
  onValuesChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  fieldId: PropTypes.string,
};

export default DashboardDemandTypeFilter;
